<template>

    <div>

        <notifier />

        <div class="top-gradient"></div>

        <nav class="navigation-menu" :class="{ 'active' : showMobileMenu }" v-if="auth">

            <div class="branding">
                <router-link to="/">
                    <img src="/images/company-portal/logo.svg">
                </router-link>
            </div>

            <div class="menu-item-container">

                <router-link to="/" tag="div" class="menu-item" @click.native="showMobileMenu = false">
                    <div class="menu-item-inner">
                        <img src="/images/company-portal/menu-item-home.svg" class="icon">
                        <img src="/images/company-portal/menu-item-home-active.svg" class="icon-active">
                        <span>Start</span>
                    </div>
                </router-link>

                <router-link to="/employees" tag="div" class="menu-item" @click.native="showMobileMenu = false">
                    <div class="menu-item-inner">
                        <img src="/images/company-portal/menu-item-employees.svg" class="icon">
                        <img src="/images/company-portal/menu-item-employees-active.svg" class="icon-active">
                        <span>Anställda</span>
                    </div>
                </router-link>

                <router-link to="/treatments" tag="div" class="menu-item" v-if="auth.company_portal_show_treatments" @click.native="showMobileMenu = false">
                    <div class="menu-item-inner">
                        <img src="/images/company-portal/menu-item-treatments.svg" class="icon">
                        <img src="/images/company-portal/menu-item-treatments-active.svg" class="icon-active">
                        <span>Behandlingar</span>
                    </div>
                </router-link>

                <router-link to="/billing" tag="div" class="menu-item" v-if="auth.type === 'admin'" @click.native="showMobileMenu = false">
                    <div class="menu-item-inner">
                        <img src="/images/company-portal/menu-item-billing.svg" class="icon">
                        <img src="/images/company-portal/menu-item-billing-active.svg" class="icon-active">
                        <span>Abonnemang</span>
                    </div>
                </router-link>

                <router-link to="/managers" tag="div" class="menu-item" v-if="auth.type === 'admin'" @click.native="showMobileMenu = false">
                    <div class="menu-item-inner">
                        <img src="/images/company-portal/menu-item-managers.svg" class="icon">
                        <img src="/images/company-portal/menu-item-managers-active.svg" class="icon-active">
                        <span>Användare</span>
                    </div>
                </router-link>

                <router-link to="/faq" tag="div" class="menu-item" @click.native="showMobileMenu = false">
                    <div class="menu-item-inner">
                        <img src="/images/company-portal/menu-item-faq.svg" class="icon">
                        <img src="/images/company-portal/menu-item-faq-active.svg" class="icon-active">
                        <span>Frågor & svar</span>
                    </div>
                </router-link>

                <router-link to="/settings" tag="div" class="menu-item" v-if="auth.type === 'admin'" @click.native="showMobileMenu = false">
                    <div class="menu-item-inner">
                        <img src="/images/company-portal/menu-item-company.svg" class="icon">
                        <img src="/images/company-portal/menu-item-company-active.svg" class="icon-active">
                        <span class="d-none d-md-inline-block">Företagsuppg.</span>
                        <span class="d-md-none">Företagsuppgifter</span>
                    </div>
                </router-link>

            </div>

            <a href="/logout" class="menu-item logout">
                <div class="menu-item-inner">
                    <span>Logga ut</span>
                    <img src="/images/company-portal/menu-item-logout.svg" class="icon">
                    <img src="/images/company-portal/menu-item-logout-active.svg" class="icon-active">
                </div>
            </a>

        </nav>

        <nav class="bottom-menu" v-if="auth">

            <div class="container-fluid px-3">

                <div class="row gx-2">
                    <div class="col-5">
                        <router-link to="/" class="bottom-menu-item">
                            <img class="icon" src="/images/company-portal/menu-item-home.svg">
                            <img class="icon-active" src="/images/company-portal/menu-item-home-active.svg">
                            <div class="w-100">Start</div>
                        </router-link>
                    </div>
                    <div class="col-7">
                        <router-link to="/employees"  class="bottom-menu-item">
                            <img class="icon" src="/images/company-portal/menu-item-employees.svg">
                            <img class="icon-active" src="/images/company-portal/menu-item-employees-active.svg">
                            <div class="w-100">Anställda</div>
                        </router-link>
                    </div>
                    <div class="col-7">
                        <router-link to="/treatments"  class="bottom-menu-item">
                            <img class="icon" src="/images/company-portal/menu-item-treatments.svg">
                            <img class="icon-active" src="/images/company-portal/menu-item-treatments-active.svg">
                            <div class="w-100">Behandlingar</div>
                        </router-link>
                    </div>
                    <div class="col-5">
                        <a class="bottom-menu-item" :class="{ 'router-link-exact-active' : showMobileMenu }" @click="showMobileMenu = !showMobileMenu">
                            <div class="hamburger">
                                <div class="bar bar1"></div>
                                <div class="bar bar2"></div>
                                <div class="bar bar3"></div>
                            </div>
                            <div class="w-100 label">Fler val</div>
                            <div class="w-100 label-active">Stäng</div>
                        </a>
                    </div>
                </div>

            </div>

        </nav>

        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>

    </div>

</template>

<script>

import notifier from './notifier'

export default {

    components: {
        notifier
    },

    data () {
        return {
            showMobileMenu: false
        }
    }
}
</script>

<style type="text/css">

    /* --- Fade transition --- */
    .fade-enter-active, .fade-leave-active {
      transition: all 500ms;
    }
    .fade-enter, .fade-leave-to {
      opacity: 0;
    }
</style>
